import { Widget } from '../../widget';
import VolatilityHeatmapContent from './volatility-heatmap-content';
import { IVolatilityHeatmapWidgetProps } from './types';
import TokenSelector from '../../token-selector';
import { useContext } from 'react';
import { VolatilityHeatmapContext } from '../../../../providers/widgets/volatility-heatmap/volatility-heatmap-provider';
import Source from '../../source';
import WidgetButtons from '../../widget-buttons';

const VolatilityHeatmapWidget = (props: IVolatilityHeatmapWidgetProps) => {
  const { widget, actions } = props;
  const { token, setToken, hasDefaultToken } = useContext(VolatilityHeatmapContext);

  return (
    <Widget cardKey={widget.key}>
      <Widget.Header>
        <Widget.Title title={widget.title} />
        <Widget.HeaderPanel>
          {<TokenSelector token={token} setToken={setToken} isFixedToken={hasDefaultToken} />}
        </Widget.HeaderPanel>
        <Widget.Buttons>
          <WidgetButtons widget={widget} actions={actions} permissions={props.permissions} />
        </Widget.Buttons>
      </Widget.Header>
      <Widget.Content>
        <VolatilityHeatmapContent providerKey={props.providerKey} />
      </Widget.Content>
      <Widget.Footer>
        <div className="footer-content">
          <Source source="Deribit" url="https://www.deribit.com" />
        </div>
      </Widget.Footer>
    </Widget>
  );
};

export default VolatilityHeatmapWidget;
